import { Routes, RouterModule } from '@angular/router';
import { CargaArchivoComponent } from './carga-archivo.component';

export const routes: Routes = [
  {
    path: '',
    component: CargaArchivoComponent,
  },
];

export const routing = RouterModule.forChild(routes);
